import createOrUpdateFocusedOtherOverrideOperation from 'owa-service/lib/operation/createOrUpdateFocusedOtherOverrideOperation';
import CreateOrUpdateFocusedOtherOverrideRequest from 'owa-service/lib/contract/CreateOrUpdateFocusedOtherOverrideRequest';
import CreateOrUpdateFocusedOtherOverrideResponse from 'owa-service/lib/contract/CreateOrUpdateFocusedOtherOverrideResponse';
import InferenceClassification from 'owa-service/lib/contract/InferenceClassification';
import { getJsonRequestHeader } from 'owa-service/lib/Utils';

/**
 * Create or Update Focused Other override action service
 * @param senderSMTPAddress sender SMTP address
 * @param inferenceClassification the inferenceClassification
 * @return the CreateOrUpdateFocusedOtherOverrideResponse
 */
export function createOrUpdateFocusedOtherOverrideService(
    senderSMTPAddress: string,
    inferenceClassification: InferenceClassification
): Promise<CreateOrUpdateFocusedOtherOverrideResponse> {
    const requestBody: CreateOrUpdateFocusedOtherOverrideRequest = {
        SenderSmtpAddress: senderSMTPAddress,
        AlwaysClassifyAs: inferenceClassification,
    };

    return createOrUpdateFocusedOtherOverrideOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    })
        .then(response => {
            return response.Body;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}
